<script>
  import Select from 'svelte-select';
  //import UploadFiles from "./UploadFiles.svelte";
  import SimpleFileUploader from '../components/SimpleFileUploader.svelte';
  import CreateMailTemplate from './CreateMailTemplate.svelte';
  import ReccuringCustom from './ReccuringCustom.svelte';
  import TaskSchedule from './TaskLibrary/TaskSchedule.svelte';
  import FormInput from './../components/FormControls/FormInput.svelte';
  import DropDown from './../components/DropDown.svelte';
  import FormTextarea from './../components/FormControls/FormTextarea.svelte';
  import Loader from './../components/Loader.svelte';
  import { getContext, onDestroy } from 'svelte';
  import { createForm } from 'svelte-forms-lib';
  import * as yup from 'yup';
  import { client } from 'root/api/index.js';
  import { Modal } from 'bootstrap';
  import { masterData, getMasterData } from '../stores/masterData.js';
  import { authStore, getUserInfo } from '../stores/auth';
  import { Popover } from 'bootstrap';
  import {
    customInputEvent,
    searchKeyByValue,
    cloneArray,
    configItem,
    validURL,
    addHttpIfNot,
    setYupMessage,
    compareArray,
    autogrowTextarea,
    getValueBySearchValue,
  } from 'components/Helper.js';
  import { flip } from 'svelte/animate';

  const recurringTypes = configItem.recurringTypes;
  const taskAction = getContext('taskAction');
  let isFormPending = false;
  let taskMailModal;
  let isRegistrationTypeSelect = false;
  let clientTypeError = false;
  let projectTypeError = false;
  let selectedTaskActivityTypeLabel = null;
  let selectedServiceTypeId = null;
  setYupMessage(yup);
  let displayfiles = [];
  let defaultValue = {
    id: '',
    unitId: '',
    name: '',
    purpose: '',
    requirement: '',
    description: '',
    taskType: 1,
    unitProjectId: '',
    responsibleParty: '',
    priority: '2',
    riskRank: 2, // When add a new Task Template, the risk rank will be assigned as Medium
    requireReview: 0,
    associatedFund: 0,
    recurring: 0,
    recurringType: '',
    recurringCustom: '',
    recurringEvery: 1,
    recurringOpenType: '',
    recurringOpenOn: '',
    recurringOpenMonth: '',
    recurringDueType: '',
    recurringDueOn: '',
    recurringDueMonth: '',
    attachments: [],
    urls: [],
    subTaskTemplates: [],
    // clientTypes:[{"id":"","unitClientTypeId": "","subClientTypes":undefined}],
    // registrationTypes:[{"id":"","unitRegistrationTypeId": "","subRegistrationTypes":undefined}],
    // projectTypes:[{"id":"","unitProjectTypeId": ""}],
    clientTypes: [],
    registrationTypes: [],
    projectTypes: [],
    emailTemplate: 0,
    emailTemplateSubject: '',
    emailTemplateBody: '',
    emailTemplateAttachments: [],
    taskActivityTypeId: '',
    taskServiceTypeId: '',
  };

  let id = 0;
  let selectedUnitProjectId;
  let newUrl = '';
  // let selectedUnitRegistrationType=[{
  //   label:null,
  //   types:null
  // }]
  // let selectedProjectTypes=[{
  //   label:null
  // }]
  // let selectedUnitClientTypes=[{
  //   label:null,
  //   types:null
  // }]
  let selectedUnitRegistrationType = [];
  let selectedProjectTypes = [];
  let selectedUnitClientTypes = [];

  let selectedUnitId = null;
  const save = () => {
    if ($form.id > 0) {
      showDialog({
        type: 'confirm',
        isTopHeading: 'N',
        extraCheckbox: true,
        title: 'Updating the template would update all scheduled task linked to this template',
        message: 'Would you like to update all open tasks linked to this template as well?',
        okFunc: (params) => {
          $form.updateOpenTask = params.extraCheckboxChecked ? 1 : 0;
          handleSubmit();
        },
      });
    } else {
      handleSubmit();
    }
  };
  let confirmUpdate = false;
  const { form, errors, handleChange, handleSubmit } = createForm({
    initialValues: cloneArray(defaultValue),
    validationSchema: yup.object().shape({
      unitId: yup.string().required('Unit Id is required'),
      name: yup.string().required('Task is required'),
      purpose: yup.string().required('Purpose is required'),
      requirement: yup.string(),
      description: yup.string().required('Short Description is required'),
      unitProjectId: yup.string().nullable(),
      taskType: yup.string().required('Task Type Id is required').nullable(),
      responsibleParty: yup.string().nullable(),
      requireReview: yup.string().nullable(),
      emailTemplate: yup.string().nullable(),
      emailTemplateSubject: yup.string().nullable(),
      emailTemplateBody: yup.string().nullable(),
      associatedFund: yup.string().nullable(),
      recurring: yup
        .string()
        .nullable()
        .when('unitId', {
          is: (value) => {
            return form.recurring == 1;
          },
          then: yup.string().required('Recurring is required').nullable(),
        }),
      recurringCustom: yup
        .string()
        .nullable()
        .when('recurring', {
          is: (value) => {
            return $form.recurring == 1 && ($form.recurringType == 0 || $form.recurringType == '');
          },
          then: yup.string().required('Required').nullable(),
        }),
      recurringType: yup
        .string()
        .nullable()
        .when('recurring', {
          is: (value) => {
            {
              return $form.recurring == 1;
            }
          },
          then: yup.string().required('Required').nullable(),
        }),

      recurringOpenType: yup
        .string()
        .nullable()
        .when('recurringType', {
          is: (value) => {
            {
              let isRequired = false;
              if (
                $form.recurring == 1 &&
                $form.recurringDueType != '' &&
                $form.recurringType == recurringTypeOptions.monthly
              ) {
                isRequired = true;
              }
              return isRequired;
            }
          },
          then: yup.string().required('Required').nullable(),
        }),
      recurringEvery: yup.number().when('recurringType', {
        is: (value) => {
          {
            return $form.recurring == 1 && $form.recurringCustom == 1;
          }
        },
        then: yup.number().required('Required').min(1).max(50),
      }),

      recurringOpenOn: yup
        .string()
        .nullable()
        .when('recurringType', {
          is: (value) => {
            {
              let isRequired = false;
              if (
                $form.recurring == 1 &&
                $form.recurringDueOn != '' &&
                ($form.recurringType == recurringTypeOptions.monthly ||
                  $form.recurringType == recurringTypeOptions.quarterly ||
                  $form.recurringType == recurringTypeOptions.annually)
              ) {
                isRequired = true;
              }
              return isRequired;
            }
          },
          then: yup.string().required('Required').nullable(),
        }),

      recurringOpenMonth: yup
        .string()
        .nullable()
        .when('recurringType', {
          is: (value) => {
            {
              return (
                $form.recurring == 1 &&
                $form.recurringDueMonth != '' &&
                ($form.recurringType == recurringTypeOptions.annually ||
                  $form.recurringType == recurringTypeOptions.quarterly)
              );
            }
          },
          then: yup.string().required('Required').nullable(),
        }),

      recurringDueType: yup
        .string()
        .nullable()
        .when('recurringType', {
          is: (value) => {
            {
              let isRequired = false;
              if (
                $form.recurring == 1 &&
                $form.recurringOpenType != '' &&
                $form.recurringType == recurringTypeOptions.monthly
              ) {
                isRequired = true;
              }
              return isRequired;
            }
          },
          then: yup.string().required('Required').nullable(),
        }),
      recurringDueOn: yup
        .string()
        .nullable()
        .when('recurringType', {
          is: (value) => {
            {
              let isRequired = false;
              if (
                $form.recurring == 1 &&
                $form.recurringOpenOn != '' &&
                ($form.recurringType == recurringTypeOptions.monthly ||
                  $form.recurringType == recurringTypeOptions.quarterly ||
                  $form.recurringType == recurringTypeOptions.annually)
              ) {
                isRequired = true;
              }
              return isRequired;
            }
          },
          then: yup.string().required('Required').nullable(),
        }),
      recurringDueMonth: yup
        .string()
        .nullable()
        .when('recurringType', {
          is: (value) => {
            {
              return (
                $form.recurring == 1 &&
                $form.recurringOpenMonth != '' &&
                ($form.recurringType == recurringTypeOptions.annually ||
                  $form.recurringType == recurringTypeOptions.quarterly)
              );
            }
          },
          then: yup.string().required('Required').nullable(),
        }),
      projectTypes: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          unitProjectTypeId: yup
            .string()
            .nullable()
            .when('taskType', {
              is: (value) => {
                return $form.taskType == taskTypeOptions.client;
              },
              then: yup.string().required('Project is required').nullable(),
            }),
        }),
      ),
      clientTypes: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          unitClientTypeId: yup
            .string()
            .nullable()
            .when('taskType', {
              is: (value) => {
                let isRequired = true;
                $form.registrationTypes.map((item, index) => {
                  if (item.unitRegistrationTypeId > 0) {
                    isRequired = false;
                  }
                });

                return $form.taskType == taskTypeOptions.client && isRequired;
              },
              then: yup.string().required('Client Type is required').nullable(),
            }),
          subClientTypes: yup.array().of(
            yup.object().shape({
              id: yup.string(),
              unitClientTypeId: yup.string(),
            }),
          ),
        }),
      ),
      registrationTypes: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          unitRegistrationTypeId: yup
            .string()
            .nullable()
            .when('taskType', {
              is: (value) => {
                let isRequired = true;
                $form.clientTypes.map((item, index) => {
                  if (item.unitClientTypeId > 0) {
                    isRequired = false;
                  }
                });

                return (
                  $form.taskType == taskTypeOptions.client && isRequired && isRegistrationTypeSelect
                );
              },
              then: yup.string().required('Registration Type is required').nullable(),
            }),
          subRegistrationTypes: yup.array().of(
            yup.object().shape({
              id: yup.string(),
              unitRegistrationTypeId: yup.string(),
            }),
          ),
        }),
      ),
    }),
    onSubmit: (values) => {
      clientTypeError =
        $form.taskType == 1 &&
        $form.clientTypes.length == 0 &&
        $form.registrationTypes.length == 0 &&
        $form.projectTypes.length == 0;
      projectTypeError =
        $form.taskType == 1 &&
        $form.clientTypes.length == 0 &&
        $form.registrationTypes.length == 0 &&
        $form.projectTypes.length == 0;
      if (clientTypeError || projectTypeError) {
        return;
      }
      if (disabledAllFields) {
        return taskAction({
          type: 'saveTaskTemplate',
          id: $form.id,
          subTaskTemplates: values.subTaskTemplates,
        });
      }
      values.confirmUpdate = confirmUpdate;
      if ($form.id > 0 && confirmUpdate == false) {
        confirmUpdate = true;
        if (
          $form.name != oldFormData.name ||
          $form.purpose != oldFormData.purpose ||
          $form.requirement != oldFormData.requirement ||
          $form.description != oldFormData.description ||
          $form.requireReview != oldFormData.requireReview ||
          compareArray($form.urls, oldFormData.urls) == false ||
          compareArray($form.attachments, oldFormData.attachments) == false ||
          compareArray($form.subTaskTemplates, oldFormData.subTaskTemplates) == false
        ) {
          if ($form.taskCount > 0) {
            return showDialog({
              type: 'confirm',
              isTopHeading: 'N',
              extraCheckbox: true,
              title:
                'Updating the template would update all scheduled task linked to this template',
              message: 'Would you like to update all open tasks linked to this template as well?',
              okFunc: (params) => {
                $form.updateOpenTask = params.extraCheckboxChecked ? 1 : 0;
                handleSubmit();
              },
              cancelFunc: () => {
                // handleSubmit()
                confirmUpdate = false;
              },
            });
          }
        } else if (
          $form.active > 0 &&
          $form.taskServiceTypeId !== oldFormData.taskServiceTypeId &&
          $form.taskCount > 0
        ) {
          return showDialog({
            type: 'confirm',
            isTopHeading: 'N',
            extraCheckbox: true,
            title:
              'Updating Service Type in the template would update all scheduled tasks linked to this template',
            message: 'Would you like to update all open tasks linked to this template as well?',
            okFunc: (params) => {
              $form.updateOpenTask = params.extraCheckboxChecked ? 1 : 0;
              handleSubmit();
            },
            cancelFunc: () => {
              confirmUpdate = false;
            },
          });
        }
      }
      let data = getFormData(values);
      isFormPending = true;
      client
        .taskTemplateSave(data)
        .then((response) => {
          isFormPending = false;
          taskAction({
            type: 'saveTaskTemplate',
          });
        })
        .catch((err) => {
          isFormPending = false;
          showDialog({ message: [err.message] });
        });
    },
  });

  const initPopupOver = () => {
    var tooltipElements = document.querySelectorAll('.popover.show');
    tooltipElements.forEach(function (el) {
      el.remove();
    });
    var elements = document.querySelectorAll('.subtask_popover');
    elements.forEach(function (el) {
      new Popover(el, { container: el.parentElement, animation: false });
    });
  };

  const getFormData = (data) => {
    let values = { ...data };
    if (values.taskType == taskTypeOptions.client) {
      values.unitProjectId = '';

      //client/registration
      //  values.projectTypes=[];

      let projectTypeArr = [];
      values.projectTypes.map((item, index) => {
        if (item.unitProjectTypeId > 0) {
          projectTypeArr.push(item);
        }
      });
      values.projectTypes = projectTypeArr;

      let clientTypeArr = [];
      values.clientTypes.map((item, index) => {
        if (item.unitClientTypeId > 0) {
          clientTypeArr.push(item);
        }
      });
      values.clientTypes = clientTypeArr;

      let registrationArr = [];
      values.registrationTypes.map((item, index) => {
        if (item.unitRegistrationTypeId > 0) {
          registrationArr.push(item);
        }
      });
      values.registrationTypes = registrationArr;
    } else {
      values.clientTypes = [];
      values.registrationTypes = [];
      values.projectTypes = [];
    }

    if (values.emailTemplate == 0) {
      values.emailTemplate = '';
    }

    let subArr = [];
    values.subTaskTemplates.map((item, index) => {
      if (item.name != '') {
        subArr.push(item);
      }
    });
    values.subTaskTemplates = subArr;

    if (values.recurring == 0) {
      values.recurringType = '';
      values.recurringCustom = '';
      values.recurringEvery = 1;
      values.recurringOpenType = '';
      values.recurringOpenOn = '';
      values.recurringOpenMonth = '';
      values.recurringDueType = '';
      values.recurringDueOn = '';
      values.recurringDueMonth = '';
    } else if (values.recurring == 1) {
      if (
        values.recurringType == recurringTypeOptions.daily ||
        values.recurringType == recurringTypeOptions.weekly
      ) {
        values.recurringOpenType = '';
        values.recurringOpenOn = '';
        values.recurringOpenMonth = '';
        values.recurringDueType = '';
        values.recurringDueOn = '';
        values.recurringDueMonth = '';
      } else if (values.recurringType == recurringTypeOptions.monthly) {
        values.recurringOpenMonth = '';
        values.recurringDueMonth = '';
      } else if (
        values.recurringType == recurringTypeOptions.annually ||
        values.recurringType == recurringTypeOptions.quarterly
      ) {
        //  values.recurringCustom="";
        //  values.recurringEvery= "";
        values.recurringOpenType = '';
        values.recurringDueType = '';
      } else if (values.recurringCustom == 0) {
        values.recurringEvery = 1;
      }
    }
    return values;
  };

  const resetRecurringData = () => {
    if (TaskScheduleOpenRef != undefined) {
      TaskScheduleOpenRef.resetRecurringData();
      TaskScheduleDueRef.resetRecurringData();
    }
  };
  let hovering = false;
  const drop = (event, target) => {
    event.dataTransfer.dropEffect = 'move';
    const start = parseInt(event.dataTransfer.getData('text/plain'));
    const newTracklist = $form.subTaskTemplates;

    if (start < target) {
      newTracklist.splice(target + 1, 0, newTracklist[start]);
      newTracklist.splice(start, 1);
    } else {
      newTracklist.splice(target, 0, newTracklist[start]);
      newTracklist.splice(start + 1, 1);
    }
    $form.subTaskTemplates = newTracklist;
    hovering = null;
  };

  const dragstart = (event, i) => {
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.dropEffect = 'move';
    const start = i;
    event.dataTransfer.setData('text/plain', start);
  };

  const showDialog = getContext('showDialog');
  let internalProjects = [];
  let projectTypes = [];
  let clientTypes = [];
  let registrationTypes = [];
  let unitMasterData;
  let clientSubArr = {};
  let registrationSubArr = {};
  const resetData = (id) => {
    if (id == 0) {
      // selectedUnitRegistrationType=[{
      //       label:null,
      //       types:null
      //   }]
      // selectedProjectTypes=[{
      //     label:null
      //   }]
      // selectedUnitClientTypes=[{
      //       label:null,
      //       types:null
      //   }]
      selectedUnitRegistrationType = [];
      selectedProjectTypes = [];
      selectedUnitClientTypes = [];
    } else {
      selectedUnitRegistrationType = [];
      selectedProjectTypes = [];
      selectedUnitClientTypes = [];
    }
    displayfiles = [];

    selectedProjectTypesLabel = null;
    selectedUnitRegistrationTypeLabel = null;
    selectedUnitClientTypesLabel = null;
    selectedTaskActivityTypeLabel = null;
    selectedServiceTypeId = null;
    clientTypeError = false;
    selectedUnitProjectId = null;
    newUrl = '';
    selectedUnitId = null;
    $form = cloneArray(defaultValue);
    confirmUpdate = false;
  };
  const getUnitMaster = () => {
    client
      .getUnitMasterData({
        unitId: $form.unitId,
        registrationTypesRequired: $form.registrationTypes,
        clientTypesRequired: $form.clientTypes,
        projectTypesRequired: $form.projectTypes,
        unitProjectIdRequired: $form.unitProjectId,
        taskActivityTypeIdRequired: $form.taskActivityTypeId,
      })
      .then((result) => {
        unitMasterData = result.data;
        internalProjects = unitMasterData.internalProjects;
        clientTypes = unitMasterData.clientTypes;
        projectTypes = unitMasterData.projectTypes;
        registrationTypes = unitMasterData.registrationTypes;
        taskActivityTypes = unitMasterData.taskActivityTypes;
        unitMasterData.clientTypes.forEach((value) => {
          clientSubArr[value.id] = value.subClientTypes;
        });
        unitMasterData.registrationTypes.forEach((value) => {
          registrationSubArr[value.id] = value.subRegistrationTypes;
        });

        if ($form.id > 0) {
          if ($form.unitProjectId > 0) {
            selectedUnitProjectId =
              internalProjects[searchKeyByValue(internalProjects, 'id', $form.unitProjectId)];
          }
          if ($form.taskActivityTypeId > 0) {
            selectedTaskActivityTypeLabel =
              taskActivityTypes[
                searchKeyByValue(taskActivityTypes, 'id', $form.taskActivityTypeId)
              ];
          }
          let oldSelectedUnitClientTypes = selectedUnitClientTypes;
          if ($form.clientTypes.length > 0) {
            $form.clientTypes.forEach((value, index) => {
              let parentKey = searchKeyByValue(clientTypes, 'id', value.unitClientTypeId);
              let currentLabel = null;
              let currentType = null;
              if (parentKey != -1) {
                currentLabel = clientTypes[parentKey];

                if (value.subClientTypes != undefined && value.subClientTypes.length > 0) {
                  let subArr = [];
                  value.subClientTypes.forEach((subvalue, subindex) => {
                    let childKey = searchKeyByValue(
                      clientTypes[parentKey].subClientTypes,
                      'id',
                      subvalue.unitClientTypeId,
                    );
                    if (childKey != -1) {
                      subArr.push(clientTypes[parentKey].subClientTypes[childKey]);
                    }
                  });
                  currentType = subArr;
                }
              }
              oldSelectedUnitClientTypes[index].label = currentLabel;
              oldSelectedUnitClientTypes[index].types = currentType;
            });
          }
          selectedUnitClientTypes = oldSelectedUnitClientTypes;

          let oldSelectedUnitRegistrationType = selectedUnitRegistrationType;
          if ($form.registrationTypes.length > 0) {
            $form.registrationTypes.forEach((value, index) => {
              let parentKey = searchKeyByValue(
                registrationTypes,
                'id',
                value.unitRegistrationTypeId,
              );
              let currentLabel = null;
              let currentType = null;
              if (parentKey != -1) {
                currentLabel = registrationTypes[parentKey];

                if (
                  value.subRegistrationTypes != undefined &&
                  value.subRegistrationTypes.length > 0
                ) {
                  let subArr = [];
                  value.subRegistrationTypes.forEach((subvalue, subindex) => {
                    let childKey = searchKeyByValue(
                      registrationTypes[parentKey].subRegistrationTypes,
                      'id',
                      subvalue.unitRegistrationTypeId,
                    );
                    if (childKey != -1) {
                      subArr.push(registrationTypes[parentKey].subRegistrationTypes[childKey]);
                    }
                  });
                  currentType = subArr;
                }
              }
              oldSelectedUnitRegistrationType[index].label = currentLabel;
              oldSelectedUnitRegistrationType[index].types = currentType;
            });
          }
          selectedUnitRegistrationType = oldSelectedUnitRegistrationType;

          let oldSelectedProjectTypes = selectedProjectTypes;
          if ($form.projectTypes.length > 0) {
            $form.projectTypes.forEach((value, index) => {
              oldSelectedProjectTypes[index].label =
                projectTypes[searchKeyByValue(projectTypes, 'id', value.unitProjectTypeId)];
            });
          }
          selectedProjectTypes = oldSelectedProjectTypes;
        }
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };
  const setClientSubTypes = (id) => {
    let arr = [];
    if (clientSubArr[id] != undefined) {
      arr = clientSubArr[id];
    }
    return arr;
  };
  const setRegistrationSubTypes = (id) => {
    let arr = [];
    if (registrationSubArr[id] != undefined) {
      arr = registrationSubArr[id];
    }
    return arr;
  };
  const addProjectType = () => {
    if (selectedProjectTypesLabel) {
      let arr = $form.projectTypes;
      if (searchKeyByValue(arr, 'unitProjectTypeId', selectedProjectTypesLabel.id) !== -1) {
        showDialog({ message: 'Project type already selected' });
      } else {
        arr.push({
          id: '',
          unitProjectTypeId: selectedProjectTypesLabel.id,
        });
        selectedProjectTypes.push({
          label: selectedProjectTypesLabel,
        });
        $form.projectTypes = arr;
        selectedProjectTypesLabel = null;
        projectTypeError = false;
      }
    } else {
      showDialog({ message: 'Please select project type' });
    }
  };
  const deleteProjectType = (key) => {
    let arr = $form.projectTypes;
    arr.splice(key, 1);
    selectedProjectTypes.splice(key, 1);
    $form.projectTypes = arr;
    // showDialog({
    //   type: "confirm",
    //   title: "",
    //   message: "Are you sure ?",
    //   okFunc: () => {
    //     let arr = $form.projectTypes;
    //     arr.splice(key, 1);
    //     selectedProjectTypes.splice(key,1)
    //     $form.projectTypes = arr;
    //   }
    // });
  };

  const addClientType = () => {
    if (selectedUnitClientTypesLabel) {
      let arr = $form.clientTypes;
      if (searchKeyByValue(arr, 'unitClientTypeId', selectedUnitClientTypesLabel.id) !== -1) {
        showDialog({ message: 'Client type already selected' });
      } else {
        arr.push({
          id: '',
          unitClientTypeId: selectedUnitClientTypesLabel.id,
          subClientTypes: undefined,
        });
        selectedUnitClientTypes.push({
          label: selectedUnitClientTypesLabel,
          types: null,
        });
        $form.clientTypes = arr;
        selectedUnitClientTypesLabel = null;
        clientTypeError = false;
      }
    } else {
      showDialog({ message: 'Please select client type' });
    }
  };
  const deleteClientType = (key) => {
    let arr = $form.clientTypes;
    arr.splice(key, 1);
    selectedUnitClientTypes.splice(key, 1);
    $form.clientTypes = arr;

    // showDialog({
    //   type: "confirm",
    //   title: "",
    //   message: "Are you sure ?",
    //   okFunc: () => {
    //     let arr = $form.clientTypes;
    //     arr.splice(key, 1);
    //     selectedUnitClientTypes.splice(key, 1);
    //     $form.clientTypes = arr;
    //   }
    // });
  };
  const addRegistrationType = () => {
    if (selectedUnitRegistrationTypeLabel) {
      let arr = $form.registrationTypes;
      if (
        searchKeyByValue(arr, 'unitRegistrationTypeId', selectedUnitRegistrationTypeLabel.id) !== -1
      ) {
        showDialog({ message: 'Registration type already selected' });
      } else {
        arr.push({
          id: '',
          unitRegistrationTypeId: selectedUnitRegistrationTypeLabel.id,
          subRegistrationTypes: undefined,
        });
        selectedUnitRegistrationType.push({
          label: selectedUnitRegistrationTypeLabel,
          types: null,
        });
        $form.registrationTypes = arr;
        selectedUnitRegistrationTypeLabel = null;
        clientTypeError = false;
      }
    } else {
      showDialog({ message: 'Please select registration type' });
    }
  };
  const deleteRegistrationType = (key) => {
    let arr = $form.registrationTypes;
    arr.splice(key, 1);
    selectedUnitRegistrationType.splice(key, 1);
    $form.registrationTypes = arr;
    // showDialog({
    //   type: "confirm",
    //   title: "",
    //   message: "Are you sure ?",
    //   okFunc: () => {
    //     let arr = $form.registrationTypes;
    //     arr.splice(key, 1);
    //     selectedUnitRegistrationType.splice(key, 1);
    //     $form.registrationTypes = arr;
    //   }
    // });
  };

  let editTaskTemplate = false;
  let addModal;
  let disabledAllFields = false;
  export const show = (taskTemplateId, comeFromModal, extraParams) => {
    disabledAllFields = comeFromModal != undefined && comeFromModal == 'assignTask';
    // disabledAllFields=true;

    addModal = new Modal(document.getElementById('addTaskTemplateModal'), {
      keyboard: false,
    });
    addModal.show();
    fetchDetail(taskTemplateId, extraParams);
  };

  export const hide = () => {
    if (addModal != undefined) {
      addModal.hide();
    }
  };

  // Service type list in the Add Task Template Modal (Add / Edit mode)
  const assignServiceType = async () => {
    if (!$form.unitId) {
      selectedServiceTypeId = null;
      taskServiceType = [];
    }
    const result = await client.sowServiceType({ units: [{ id: $form.unitId }] });
    taskServiceType = result?.data?.payload || [];
    if ($form.taskServiceTypeId > 0) {
      selectedServiceTypeId =
        taskServiceType[searchKeyByValue(taskServiceType, 'id', $form.taskServiceTypeId)];
    }
  };

  let oldFormData;
  const fetchDetail = (requestId, extraParams) => {
    id = requestId != undefined ? requestId : 0;
    editTaskTemplate = id > 0;
    $errors = {};
    resetData(id);
    if (id > 0) {
      client
        .taskTemplateGet({ id: id })
        .then((response) => {
          let registrationTypesArr = response.data.registrationTypes;
          let oldSelectedUnitRegistrationType = [];
          if (registrationTypesArr.length > 0) {
            registrationTypesArr.forEach((value, index) => {
              oldSelectedUnitRegistrationType.push({
                label: null,
                types: null,
              });
            });
          }
          selectedUnitRegistrationType = oldSelectedUnitRegistrationType;
          let projectTypesArr = response.data.projectTypes;
          let oldSelectedProjectTypes = [];
          if (projectTypesArr.length > 0) {
            projectTypesArr.forEach((value, index) => {
              oldSelectedProjectTypes.push({
                label: null,
              });
            });
          }
          selectedProjectTypes = oldSelectedProjectTypes;
          let clientTypesArr = response.data.clientTypes;
          let oldSelectedUnitClientTypes = [];
          if (clientTypesArr.length > 0) {
            clientTypesArr.forEach((value, index) => {
              oldSelectedUnitClientTypes.push({
                label: null,
                types: null,
              });
            });
          }
          selectedUnitClientTypes = oldSelectedUnitClientTypes;

          $form = response.data;
          displayfiles = $form.attachments;

          oldFormData = cloneArray($form);

          if ($form.recurringType == 0) {
            $form.recurringType = '';
          }
          if ($form.recurringOpenType == 0) {
            $form.recurringOpenType = '';
          }
          if ($form.recurringDueType == 0) {
            $form.recurringDueType = '';
          }
          if ($form.recurringOpenOn == 0) {
            $form.recurringOpenOn = '';
          }
          if ($form.recurringDueOn == 0) {
            $form.recurringDueOn = '';
          }
          if ($form.recurringCustom == 0) {
            $form.recurringEvery = 1;
          }
          if ($form.unitId > 0) {
            selectedUnitId = businessUnits[searchKeyByValue(businessUnits, 'id', $form.unitId)];
            getUnitMaster();
            assignServiceType();
            selectedTaskActivityTypeLabel =
              taskActivityTypes[
                searchKeyByValue(taskActivityTypes, 'id', $form.taskActivityTypeId)
              ];
          }

          if (extraParams != undefined && extraParams.subTaskTemplates != undefined) {
            $form.subTaskTemplates = extraParams.subTaskTemplates;
          }

          if (disabledAllFields === true) {
            setTimeout(() => {
              initPopupOver();
              document.getElementById('main_page_content').scrollTop =
                document.getElementById('sub_task_area_block').offsetTop;
            }, 400);
          }

          // if($form.projectTypes.length ==0){
          //   addProjectType();
          // }
          // if($form.clientTypes.length ==0){
          //   addClientType();
          // }
          // if($form.registrationTypes.length ==0){
          //   addRegistrationType();
          // }

          resetAutoGrow();
        })
        .catch((err) => {})
        .catch();
    }
  };

  const addSubTask = () => {
    let oldSubTasks = $form.subTaskTemplates;
    if (oldSubTasks.length > 0 && oldSubTasks[oldSubTasks.length - 1].name.trim() == '') {
      showDialog({ message: 'Please Enter Sub Task Name' });
      return false;
    }
    oldSubTasks = oldSubTasks.map((item) => {
      item.autoFocus = false;
      item.name = item.name.trim();
      return item;
    });
    oldSubTasks.push({ name: '', autoFocus: true });
    $form.subTaskTemplates = oldSubTasks;
    setTimeout(() => {
      const items = [...document.getElementsByClassName('sub-task-input')];
      items[$form.subTaskTemplates.length - 1].focus();
    }, 100);
  };

  let businessUnits = [];
  let taskActivityTypes = [];
  let taskServiceType = [];
  let recurringType = [];
  let taskTypeOptions = [];
  let recurringTypeOptions;
  let userRolesIndex = null;
  let userRoleId = getUserInfo().roleId;
  let openDateRecurringSubType = [];
  let dueDateRecurringSubType = [];

  const unsubscribe = masterData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        businessUnits = getMasterData().units;
        recurringType = getMasterData().recurringType;
        recurringTypeOptions = getMasterData().recurringType;
        taskTypeOptions = getMasterData().taskType;
        userRolesIndex = getMasterData().userRoleId;
        openDateRecurringSubType = getMasterData().openDateRecurringSubType;
        dueDateRecurringSubType = getMasterData().dueDateRecurringSubType;
        taskActivityTypes = getMasterData().taskActivityTypes;
      }
    });
  });
  onDestroy(() => {
    unsubscribe();
  });

  let TaskScheduleOpenRef;
  let TaskScheduleDueRef;

  const validateClientRegistrationTypes = () => {
    $form.clientTypes.forEach((item, key) => {
      handleChange(customInputEvent(`clientTypes[${key}].unitClientTypeId`, item.unitClientTypeId));
    });
    $form.registrationTypes.forEach((item, key) => {
      if (item.unitRegistrationTypeId > 0) {
        isRegistrationTypeSelect = true;
      }
      handleChange(
        customInputEvent(
          `registrationTypes[${key}].unitRegistrationTypeId`,
          item.unitRegistrationTypeId,
        ),
      );
    });
  };

  let selectedProjectTypesLabel;
  let selectedUnitRegistrationTypeLabel;
  let selectedUnitClientTypesLabel;
  let selectedActivityTypesLabel;
  let urlInvalid = false;
  let newTitle = '';
  const addUrl = () => {
    if (newUrl != '') {
      if (validURL(newUrl)) {
        let oldUrls = $form.urls;
        oldUrls.push({ url: addHttpIfNot(newUrl), title: newTitle });
        $form.urls = oldUrls;
        newUrl = '';
        newTitle = '';
        urlInvalid = false;
      } else {
        urlInvalid = 'Invalid Url';
      }
    } else {
      urlInvalid = 'Required';
    }
  };
  const getResposiblePartyLabel = (form) => {
    if (selectedUnitId) {
      return selectedUnitId.responsible_party_name;
    } else {
      return 'Us';
    }
  };

  const resetAutoGrow = () => {
    setTimeout(() => {
      document.querySelectorAll('.sub-task-input').forEach(function (el) {
        autogrowTextarea(el);
      });
    }, 500);
  };

  const deleteEmailTemplate = () => {
    showDialog({
      type: 'confirm',
      message: 'Are you are you want to delete the mail template?',
      okFunc: (params) => {
        client
          .taskTemplateEmailDelete({ id: $form.id })
          .then((response) => {
            fetchDetail($form.id);
          })
          .catch((err) => {})
          .catch();
      },
    });
  };
</script>

<div>
  <div
    class="modal fade slide-modal"
    id="addTaskTemplateModal"
    tabindex="-1"
    aria-labelledby="taskTemplateModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog w-100 add-task-modal h-100 m-0 float-end">
      <div class="modal-content">
        <div class="d-flex flex-column h-100">
          <div class="modal-header rounded-0">
            <h5 class="modal-title font-size-14">
              {id > 0 ? 'Edit' : 'Add'} Task Template
            </h5>
            <button
              type="button"
              class="close btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" />
            </button>
          </div>
          <div
            class="page-content"
            id="main_page_content"
          >
            <div class="form-slect-comp form-input-area">
              <div class="row align-items-center">
                <div class="col-md-9 d-flex">
                  <div
                    class="form-group select-block select-client-type me-1 position-relative business-template {$errors.unitId
                      ? 'error'
                      : ''}"
                  >
                    <Select
                      bind:selectedValue={selectedUnitId}
                      items={businessUnits}
                      placeholder="Select Business Unit"
                      showChevron={true}
                      isClearable={true}
                      isDisabled={id > 0 || disabledAllFields}
                      getSelectionLabel={(option) => {
                        return option.name;
                      }}
                      containerClasses="form-control"
                      on:select={(ev) => {
                        if ($form.unitId != ev.detail.id) {
                          $form.unitId = ev.detail.id;
                          assignServiceType();
                          getUnitMaster();
                        }
                      }}
                      on:clear={() => {
                        taskServiceType = [];
                        selectedServiceTypeId = null;
                      }}
                      optionIdentifier="id"
                      getOptionLabel={(option) => {
                        return option.name;
                      }}
                    ></Select>

                    {#if $errors.unitId}
                      <label
                        class="formError"
                        for=""
                      >
                        {$errors.unitId}
                      </label>
                    {/if}
                  </div>
                  <!-- Select should not appear if doesn't have unitId and when taskType is Internal (id: 2) -->
                  {#if $form.unitId > 0 && $form.taskType !== 2}
                    <!-- Select Service Type select -->
                    <div
                      class="form-group select-block select-client-type me-2 business-template position-relative"
                    >
                      <Select
                        showChevron={true}
                        isClearable={true}
                        bind:selectedValue={selectedServiceTypeId}
                        placeholder="Select Service Type"
                        items={taskServiceType}
                        getSelectionLabel={(option) => {
                          return option.name;
                        }}
                        optionIdentifier="id"
                        getOptionLabel={(option) => {
                          return option.name;
                        }}
                        containerClasses="form-control"
                        on:select={(ev) => {
                          $form.taskServiceTypeId = ev.detail.id;
                        }}
                        on:clear={() => {
                          $form.taskServiceTypeId = null;
                        }}
                      ></Select>
                    </div>
                    <div
                      class="form-group select-block select-client-type ms-2 position-relative business-activity-template {$errors.unitId
                        ? 'error'
                        : ''}"
                    >
                      <Select
                        bind:selectedValue={selectedTaskActivityTypeLabel}
                        items={taskActivityTypes}
                        placeholder="Select Activity Type"
                        showChevron={true}
                        isClearable={true}
                        isDisabled={id > 0 && disabledAllFields}
                        getSelectionLabel={(option) => {
                          return option.name;
                        }}
                        containerClasses="form-control"
                        on:select={(ev) => {
                          $form.taskActivityTypeId = ev.detail.id;
                        }}
                        on:clear={() => {
                          $form.taskActivityTypeId = null;
                        }}
                        optionIdentifier="id"
                        getOptionLabel={(option) => {
                          return option.name;
                        }}
                      ></Select>

                      {#if $errors.unitId}
                        <label
                          class="formError"
                          for=""
                        >
                          {$errors.unitId}
                        </label>
                      {/if}
                    </div>
                  {/if}
                </div>

                <div class="col-md-3 text-end">
                  {#if $form.unitId > 0 && userRolesIndex && userRolesIndex.manager != userRoleId}
                    <button
                      disabled={disabledAllFields}
                      on:click={() => {
                        taskMailModal.showModal(
                          $form.emailTemplateSubject,
                          $form.emailTemplateBody,
                          $form.emailTemplateAttachments,
                          $form.emailTemplateBody,
                          $form.id > 0 && $form.emailTemplate == 1,
                        );
                      }}
                      type="button"
                      class="btn bg-transparent btn-link btn-email-template mb-0 font-size-12 shadow-none border-0 px-0"
                    >
                      <img
                        style="    position: relative;     top: -1px;"
                        class="icon-12"
                        alt=""
                        src={$form.id > 0 ? '/images/pencil-gray.svg' : '/images/plus.svg'}
                      />
                      {$form.id > 0 ? 'Edit' : 'Create'} Email Template
                    </button>
                  {/if}

                  {#if editTaskTemplate == true}
                    <div
                      class="position-relative d-flex justify-content-end"
                      style="width:100px;float:right;"
                    >
                      <DropDown
                        showIcon={false}
                        checkbox={false}
                        deleteSelected={false}
                        active={true}
                        titleChanged={true}
                        extraClass={getValueBySearchValue(
                          configItem.priority,
                          'id',
                          $form.priority,
                          'extraClass',
                        )}
                        icon={getValueBySearchValue(
                          configItem.priority,
                          'id',
                          $form.priority,
                          'icon',
                        )}
                        title={getValueBySearchValue(
                          configItem.priority,
                          'id',
                          $form.priority,
                          'name',
                        )}
                        defaultTitle="Priority"
                        on:onSelect={(item) => {
                          $form.priority = item.detail.id;
                        }}
                        option={configItem.priority}
                        Style="select-block priority-dropdown-template"
                      />
                    </div>
                  {/if}
                </div>
              </div>
            </div>
            <div class="modal-form-area form-input-area border-0">
              {#if $form.unitId > 0}
                <div class="form-group mb-3">
                  <FormInput
                    disabled={disabledAllFields}
                    maxLength={configItem.maxLength.input}
                    name="name"
                    label="Task"
                    type="text"
                    placeholder="Task"
                    handleChange={handleChange}
                    error={$errors.name}
                    bind:value={$form.name}
                  />
                </div>
                <div class="form-group mb-3">
                  <FormTextarea
                    disabled={disabledAllFields}
                    maxLength={configItem.maxLength.textarea}
                    name="purpose"
                    label="Purpose"
                    placeholder="Purpose"
                    handleChange={handleChange}
                    error={$errors.purpose}
                    bind:value={$form.purpose}
                  />
                </div>
                <div class="form-group mb-3">
                  <FormTextarea
                    disabled={disabledAllFields}
                    maxLength={configItem.maxLength.textarea}
                    name="requirement"
                    label="Requirement"
                    placeholder="Requirement"
                    handleChange={handleChange}
                    error={$errors.requirement}
                    bind:value={$form.requirement}
                  />
                </div>
                <div class="form-group mb-3">
                  <FormTextarea
                    disabled={disabledAllFields}
                    maxLength={configItem.maxLength.description}
                    name="description"
                    label="Short Description"
                    placeholder="Short Description"
                    handleChange={handleChange}
                    error={$errors.description}
                    bind:value={$form.description}
                    Style="height:100px"
                  />
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-label">
                        <div class="checkbox c-checkbox">
                          <label>
                            <input
                              type="checkbox"
                              name="requireReview"
                              disabled={disabledAllFields}
                              checked={$form.requireReview == 1}
                              on:change={(event) =>
                                ($form.requireReview = event.target.checked ? 1 : 0)}
                            />
                            <span class="check-img" />
                            Requires Collaborator Review
                          </label>
                        </div>
                      </div>
                    </div>
                    {#if $form.taskType == 1}
                      <div class="col-md-6">
                        <div class="form-label position-relative">
                          <div
                            class="checkbox c-checkbox {$errors.associatedFund != undefined
                              ? 'error'
                              : ''}"
                          >
                            <label>
                              <input
                                disabled={disabledAllFields}
                                type="checkbox"
                                name="associatedFund"
                                checked={$form.associatedFund == 1}
                                on:change={(event) => {
                                  $form.associatedFund = event.target.checked ? 1 : 0;
                                  handleChange(
                                    customInputEvent(
                                      `associatedFund`,
                                      event.target.checked ? 1 : 0,
                                    ),
                                  );
                                }}
                              />
                              <span class="check-img" />
                              Associated with Funds
                            </label>
                          </div>
                          {#if $errors.associatedFund != undefined}
                            <label
                              for=""
                              class="formError"
                              style="left: 0px;right: auto;bottom: -19px;"
                              >{$errors.associatedFund}</label
                            >
                          {/if}
                        </div>
                      </div>
                    {/if}
                  </div>
                </div>

                <!-- Tabs Start -->
                <div class="tabs-block p-3">
                  <div class="tabs-area bg-white">
                    <div class="bg-white tabs-content-area">
                      <div class="d-flex flex-row align-items-center justify-content-center">
                        <div
                          class="btn-group"
                          role="group"
                          aria-label="Basic example"
                        >
                          <button
                            disabled={id > 0 || disabledAllFields}
                            on:click={() => ($form.taskType = taskTypeOptions.client)}
                            type="button"
                            class="btn font-size-12 tabber-btn d-flex flex-row shadow-none {$form.taskType ==
                            taskTypeOptions.client
                              ? 'active'
                              : null}"
                          >
                            <svg
                              version="1.1"
                              id="Capa_1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              x="0px"
                              y="0px"
                              viewBox="0 0 512 512"
                              style="enable-background:new 0 0 512 512;"
                              xml:space="preserve"
                              ><g
                                ><g
                                  ><path
                                    d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148                            C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962                            c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216                            h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40                            c59.551,0,108,48.448,108,108S315.551,256,256,256z"
                                  /></g
                                ></g
                              ></svg
                            >
                            Client
                          </button>
                          <button
                            disabled={id > 0 || disabledAllFields}
                            on:click={() => ($form.taskType = taskTypeOptions.project)}
                            type="button"
                            class="btn font-size-12 tabber-btn d-flex flex-row shadow-none {$form.taskType ==
                            taskTypeOptions.project
                              ? 'active'
                              : null}"
                          >
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.7069 1.412L7.45688 11.699H11.0469V13.699H4.04688V6.699H6.04688V10.279L16.2919 0L17.7079 1.412H17.7069Z"
                              />
                              <path
                                d="M8 1.70599V3.70599H2V15.706H14V9.70599H16V17.706H0V1.70599H8V1.70599Z"
                              />
                            </svg>
                            Internal
                          </button>
                        </div>
                      </div>
                      {#if $form.taskType == taskTypeOptions.client}
                        <div class="row fade show">
                          <div class="tabs-header-block">
                            <div class="header-tab-btn">
                              <button
                                style="font-size: 16px;padding-left: 0 !important;margin-left: 0 !important;"
                                disabled={id > 0 || disabledAllFields}
                                class="mb-0 bg-transparent shadow-none border-0 rounded-0 mx-3"
                                >Ongoing</button
                              >
                            </div>
                          </div>

                          <div
                            class="tab-content client-tabs-block"
                            id="myClientTabContent"
                          >
                            <div class="">
                              <div
                                class="d-flex flex-row align-items-center justify-content-start add-client-title mb-3"
                              >
                                <span class="font-weight-500">Client</span>
                                <div class="hrline w-100 ms-3"></div>
                              </div>

                              <div class="form-group mb-2">
                                <div class="row align-items-center">
                                  <div class="col-md-3">
                                    <label
                                      for=""
                                      class="form-label mb-0">Type</label
                                    >
                                  </div>
                                  <div class="col-md-6">
                                    <div
                                      class="d-flex flex-row form-group select-block select-client-type position-relative"
                                    >
                                      <Select
                                        isDisabled={disabledAllFields}
                                        class="form-control"
                                        showChevron={true}
                                        isClearable={true}
                                        bind:selectedValue={selectedUnitClientTypesLabel}
                                        placeholder="Client Type"
                                        on:select={(ev) => {
                                          selectedUnitClientTypesLabel = ev.detail;
                                          addClientType();
                                          setTimeout(() => {
                                            selectedUnitClientTypesLabel = undefined;
                                          }, 100);
                                        }}
                                        items={clientTypes}
                                        containerClasses="form-control"
                                        optionIdentifier="id"
                                        getSelectionLabel={(option) => {
                                          return option.name;
                                        }}
                                        getOptionLabel={(option) => {
                                          return option.name;
                                        }}
                                      />
                                      {#if clientTypeError}
                                        <label
                                          class="formError"
                                          for="id"
                                        >
                                          Please add at least one client type or registration type
                                        </label>
                                      {/if}
                                    </div>
                                  </div>
                                  <div class="col-md-3 text-end">
                                    <!-- <button
												  disabled={disabledAllFields}
												  class="bg-transparent border-0 color-blue pt-0" on:click={() => addClientType()}>+ Add New</button>                                                     -->
                                  </div>
                                </div>
                              </div>

                              {#each $form.clientTypes as item, key}
                                {#if item.deleted == undefined}
                                  <div class="form-group mb-2">
                                    <div class="row align-items-center">
                                      <div class="col-md-3">
                                        <label
                                          for=""
                                          class="form-label mb-0">Type</label
                                        >
                                      </div>
                                      <div class="col-md-9">
                                        <div
                                          class="d-flex flex-row form-group select-block select-client-type position-relative {$errors.clientTypes !=
                                            undefined &&
                                          $errors.clientTypes[key] != undefined &&
                                          $errors.clientTypes[key].unitClientTypeId != ''
                                            ? 'error'
                                            : ''}"
                                        >
                                          <Select
                                            isDisabled={true || disabledAllFields}
                                            class="form-control"
                                            showIndicator={id > 0 && key == 0 ? false : true}
                                            isClearable={id > 0 && key == 0 ? true : false}
                                            name={'clientTypes[' + key + ']'}
                                            bind:selectedValue={selectedUnitClientTypes[key].label}
                                            placeholder="Client Type"
                                            on:clear={(ev) => {
                                              if (key == 0) {
                                                $form.clientTypes[key].unitClientTypeId = '';
                                                $form.clientTypes[key].subClientTypes = undefined;
                                                setTimeout(() => {
                                                  selectedUnitClientTypes[key].types = null;
                                                }, 100);
                                                //handleChange(customInputEvent(`clientTypes[${key}].unitClientTypeId`, ""));
                                                validateClientRegistrationTypes();
                                              }
                                            }}
                                            on:select={(ev) => {
                                              if (
                                                $form.clientTypes[key].unitClientTypeId !=
                                                ev.detail.id
                                              ) {
                                                $form.clientTypes[key].unitClientTypeId =
                                                  ev.detail.id;
                                                $form.clientTypes[key].subClientTypes = undefined;
                                                setTimeout(() => {
                                                  selectedUnitClientTypes[key].types = null;
                                                }, 100);
                                                // handleChange(customInputEvent(`clientTypes[${key}].unitClientTypeId`, ev.detail.id));
                                                validateClientRegistrationTypes();
                                              } else if (
                                                setClientSubTypes(
                                                  $form.clientTypes[key].unitClientTypeId,
                                                ).length > 0
                                              ) {
                                                //handleChange(customInputEvent(`clientTypes[${key}].unitClientTypeId`, $form.clientTypes[key].unitClientTypeId));
                                                validateClientRegistrationTypes();
                                              }
                                            }}
                                            items={clientTypes}
                                            containerClasses="form-control"
                                            optionIdentifier="id"
                                            getSelectionLabel={(option) => {
                                              return option.name;
                                            }}
                                            getOptionLabel={(option) => {
                                              return option.name;
                                            }}
                                          />
                                          {#if $errors.clientTypes != undefined && $errors.clientTypes[key] != undefined && $errors.clientTypes[key].unitClientTypeId != ''}
                                            <label
                                              class="formError"
                                              for=""
                                              >{$errors.clientTypes[key].unitClientTypeId}</label
                                            >
                                          {/if}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {#if setClientSubTypes($form.clientTypes[key].unitClientTypeId).length != 0}
                                    <div class="form-group mb-2">
                                      <div class="row align-items-center">
                                        <div class="col-md-3">
                                          <label
                                            for=""
                                            class="form-label mb-0"
                                            >Sub Type
                                            <small>(Optional)</small></label
                                          >
                                        </div>
                                        <div class="col-md-9">
                                          <div
                                            class="d-flex flex-row form-group select-client-type sub-type-block client-reg-subtype"
                                          >
                                            <Select
                                              isDisabled={disabledAllFields}
                                              class="form-control"
                                              bind:selectedValue={
                                                selectedUnitClientTypes[key].types
                                              }
                                              isMulti={true}
                                              containerStyles="width:100%"
                                              name={'subClientTypes[' + key + ']'}
                                              showChevron={true}
                                              isClearable={true}
                                              placeholder="Sub Type"
                                              on:select={(ev) => {
                                                let subArr = [];
                                                if (ev.detail !== null) {
                                                  ev.detail.forEach((element) => {
                                                    subArr.push({
                                                      id: '',
                                                      unitClientTypeId: element.id,
                                                    });
                                                  });
                                                }
                                                $form.clientTypes[key].subClientTypes = subArr;
                                              }}
                                              items={setClientSubTypes(
                                                $form.clientTypes[key].unitClientTypeId,
                                              )}
                                              optionIdentifier="id"
                                              getSelectionLabel={(option) => {
                                                return option.name;
                                              }}
                                              getOptionLabel={(option) => {
                                                return option.name;
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  {/if}

                                  <div class="row justify-content-end">
                                    <div class="col-md-9 text-end">
                                      <!-- {#if key == 0}
													<button
													disabled={disabledAllFields}
													 class="bg-transparent border-0 color-blue pt-0" on:click={() => addClientType()}>+ Add</button>
													{:else} -->
                                      <button
                                        disabled={disabledAllFields}
                                        class="btn btn-link px-0 mb-0 box-shadow-none pt-0 border-0 font-size-12 color-red shadow-none bg-transparent mt-0"
                                        on:click={() => {
                                          deleteClientType(key);
                                        }}
                                      >
                                        <img
                                          alt=""
                                          class="icon-16 me-1"
                                          src="/images/trash.svg"
                                        />
                                        Remove
                                      </button>
                                      <!-- {/if}  -->
                                      <hr class="mb-2 mt-2" />
                                    </div>
                                  </div>
                                {/if}
                              {/each}
                              <div
                                class="d-flex flex-row align-items-center justify-content-start add-client-title mb-3"
                              >
                                <span class="font-weight-500">Registration</span>
                                <div class="hrline w-100 ms-3"></div>
                              </div>

                              <div class="form-group mb-3">
                                <div class="row align-items-center">
                                  <div class="col-md-3">
                                    <label
                                      for=""
                                      class="form-label mb-0">Type</label
                                    >
                                  </div>
                                  <div class="col-md-6">
                                    <div
                                      class="d-flex flex-row form-group select-block select-client-type position-relative"
                                    >
                                      <Select
                                        isDisabled={disabledAllFields}
                                        class="form-control"
                                        bind:selectedValue={selectedUnitRegistrationTypeLabel}
                                        showChevron={true}
                                        isClearable={true}
                                        containerClasses="form-control"
                                        placeholder="Registration Type"
                                        on:select={(ev) => {
                                          selectedUnitRegistrationTypeLabel = ev.detail;
                                          addRegistrationType();
                                          setTimeout(() => {
                                            selectedUnitRegistrationTypeLabel = undefined;
                                          }, 100);
                                        }}
                                        items={registrationTypes}
                                        optionIdentifier="id"
                                        getSelectionLabel={(option) => {
                                          return option.name;
                                        }}
                                        getOptionLabel={(option) => {
                                          return option.name;
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <!-- <div class="col-md-3  text-end">
											  <button disabled={disabledAllFields} class="bg-transparent border-0 color-blue" on:click={() => addRegistrationType()}>+ Add New</button>
											</div> -->
                                </div>
                              </div>
                              {#each $form.registrationTypes as item, key}
                                {#if item.deleted == undefined}
                                  <div class="form-group mb-3">
                                    <div class="row align-items-center">
                                      <div class="col-md-3">
                                        <label
                                          for=""
                                          class="form-label mb-0">Type</label
                                        >
                                      </div>
                                      <div class="col-md-9">
                                        <div
                                          class="d-flex flex-row form-group select-block select-client-type position-relative {$errors.registrationTypes !=
                                            undefined &&
                                          $errors.registrationTypes[key] != undefined &&
                                          $errors.registrationTypes[key].unitRegistrationTypeId !=
                                            ''
                                            ? 'error'
                                            : ''}"
                                        >
                                          <Select
                                            isDisabled={true || disabledAllFields}
                                            class="form-control"
                                            bind:selectedValue={
                                              selectedUnitRegistrationType[key].label
                                            }
                                            showIndicator={id > 0 && key == 0 ? false : true}
                                            isClearable={id > 0 && key == 0 ? true : false}
                                            name={'registrationTypes[' + key + ']'}
                                            containerClasses="form-control"
                                            placeholder="Registration Type"
                                            on:clear={(ev) => {
                                              if (key == 0) {
                                                $form.registrationTypes[
                                                  key
                                                ].unitRegistrationTypeId = '';
                                                $form.registrationTypes[key].subRegistrationTypes =
                                                  undefined;
                                                setTimeout(() => {
                                                  selectedUnitRegistrationType[key].types = null;
                                                }, 100);

                                                //handleChange(customInputEvent(`registrationTypes[${key}].unitRegistrationTypeId`, ""));
                                                validateClientRegistrationTypes();
                                              }
                                            }}
                                            on:select={(ev) => {
                                              if (
                                                $form.registrationTypes[key]
                                                  .unitRegistrationTypeId != ev.detail.id
                                              ) {
                                                $form.registrationTypes[
                                                  key
                                                ].unitRegistrationTypeId = ev.detail.id;
                                                $form.registrationTypes[key].subRegistrationTypes =
                                                  undefined;
                                                setTimeout(() => {
                                                  selectedUnitRegistrationType[key].types = null;
                                                }, 100);
                                                // handleChange(customInputEvent(`registrationTypes[${key}].unitRegistrationTypeId`, ev.detail.id));
                                                validateClientRegistrationTypes();
                                              } else if (
                                                setRegistrationSubTypes(
                                                  $form.registrationTypes[key]
                                                    .unitRegistrationTypeId,
                                                ).length > 0
                                              ) {
                                                // handleChange(customInputEvent(`registrationTypes[${key}].unitRegistrationTypeId`, $form.registrationTypes[key].unitRegistrationTypeId));
                                                validateClientRegistrationTypes();
                                              }
                                            }}
                                            items={registrationTypes}
                                            optionIdentifier="id"
                                            getSelectionLabel={(option) => {
                                              return option.name;
                                            }}
                                            getOptionLabel={(option) => {
                                              return option.name;
                                            }}
                                          />

                                          {#if $errors.registrationTypes != undefined && $errors.registrationTypes[key] != undefined && $errors.registrationTypes[key].unitRegistrationTypeId != ''}
                                            <label
                                              for=""
                                              class="formError"
                                              >{$errors.registrationTypes[key]
                                                .unitRegistrationTypeId}</label
                                            >
                                          {/if}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {#if setRegistrationSubTypes($form.registrationTypes[key].unitRegistrationTypeId).length != 0}
                                    <div class="form-group mb-2">
                                      <div class="row align-items-center">
                                        <div class="col-md-3">
                                          <label
                                            for=""
                                            class="form-label mb-0"
                                            >Sub Type
                                            <small>(Optional)</small></label
                                          >
                                        </div>
                                        <div class="col-md-9">
                                          <div class="d-flex flex-row w-100">
                                            <Select
                                              isDisabled={disabledAllFields}
                                              class="form-control"
                                              bind:selectedValue={
                                                selectedUnitRegistrationType[key].types
                                              }
                                              isMulti={true}
                                              name={'subRegistrationTypes[' + key + ']'}
                                              containerStyles="width:100%"
                                              showChevron={true}
                                              isClearable={true}
                                              placeholder="Sub Type"
                                              on:select={(ev) => {
                                                let subArr = [];
                                                if (ev.detail !== null) {
                                                  ev.detail.forEach((element) => {
                                                    subArr.push({
                                                      id: '',
                                                      unitRegistrationTypeId: element.id,
                                                    });
                                                  });
                                                }
                                                $form.registrationTypes[key].subRegistrationTypes =
                                                  subArr;
                                              }}
                                              on:clear={(ev) => {}}
                                              items={setRegistrationSubTypes(
                                                $form.registrationTypes[key].unitRegistrationTypeId,
                                              )}
                                              optionIdentifier="id"
                                              getSelectionLabel={(option) => {
                                                return option.name;
                                              }}
                                              getOptionLabel={(option) => {
                                                return option.name;
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  {/if}
                                  <div class="row justify-content-end">
                                    <div class="col-md-9 text-end">
                                      <!-- {#if key == 0}
													<button disabled={disabledAllFields} class="bg-transparent border-0 color-blue" on:click={() => addRegistrationType()}>+ Add</button>
													{:else} -->
                                      <button
                                        disabled={disabledAllFields}
                                        class="btn btn-link px-0 mb-0 box-shadow-none border-0 font-size-12 color-red shadow-none bg-transparent mt-0 pt-0"
                                        on:click={() => {
                                          deleteRegistrationType(key);
                                        }}
                                      >
                                        <img
                                          alt=""
                                          class="icon-16 me-1"
                                          src="/images/trash.svg"
                                        />
                                        Remove
                                      </button>
                                      <!-- {/if}       -->
                                      <hr class="mb-2 mt-0" />
                                    </div>
                                  </div>
                                {/if}
                              {/each}
                              <div class="row mt-3"></div>
                            </div>
                          </div>
                        </div>
                        <div class="row fade show">
                          <div class="tabs-header-block">
                            <div class="header-tab-btn">
                              <button
                                disabled={id > 0 || disabledAllFields}
                                class="mb-0 bg-transparent shadow-none border-0 rounded-0 mx-3"
                                style="font-size: 16px;padding-left: 0 !important;margin-left: 0 !important;"
                                >Project</button
                              >
                            </div>
                          </div>

                          <div
                            class="tab-content client-tabs-block"
                            id="myClientTabContent"
                          >
                            <div class="">
                              <div
                                class="d-flex flex-row align-items-center justify-content-start add-client-title mb-3"
                              >
                                <span class="font-weight-500">Project</span>
                                <div class="hrline w-100 ms-3"></div>
                              </div>
                              <div class="form-group mb-3">
                                <div class="row align-items-center mb-3">
                                  <div class="col-md-3">
                                    <label
                                      for=""
                                      class="form-label mb-0">Project</label
                                    >
                                  </div>
                                  <div class="col-md-9">
                                    <div
                                      class="d-flex flex-row form-group select-block select-client-type position-relative"
                                    >
                                      <div class="position-relative w-100">
                                        <Select
                                          isDisabled={disabledAllFields}
                                          containerStyles="min-width:200px;"
                                          class="form-control select-project-type"
                                          bind:selectedValue={selectedProjectTypesLabel}
                                          showChevron={true}
                                          isClearable={true}
                                          placeholder="Project"
                                          on:select={(ev) => {
                                            selectedProjectTypesLabel = ev.detail;
                                            addProjectType();
                                            setTimeout(() => {
                                              selectedProjectTypesLabel = undefined;
                                            }, 100);
                                          }}
                                          items={projectTypes}
                                          containerClasses="form-control"
                                          optionIdentifier="id"
                                          getSelectionLabel={(option) => {
                                            return option.name;
                                          }}
                                          getOptionLabel={(option) => {
                                            return option.name;
                                          }}
                                        />
                                        {#if projectTypeError}
                                          <label
                                            class="formError"
                                            for="id"
                                          >
                                            Please add at least one project type
                                          </label>
                                        {/if}
                                      </div>
                                      <!-- <div class="add-more-btn  d-flex align-itms-center  justify-content-start">
													  <button disabled={disabledAllFields} class="bg-transparent shadow-none border-0 color-blue ps-0" on:click={() => addProjectType()}>+ Add New</button>
													</div> -->
                                    </div>
                                  </div>
                                </div>
                                {#each $form.projectTypes as item, key}
                                  <div class="row align-items-center mb-3">
                                    <div class="col-md-3">
                                      <label
                                        for=""
                                        class="form-label mb-0">Project</label
                                      >
                                    </div>
                                    <div class="col-md-9">
                                      <div
                                        class="d-flex flex-row form-group select-block select-client-type position-relative {$errors.projectTypes !=
                                          undefined &&
                                        $errors.projectTypes[key] != undefined &&
                                        $errors.projectTypes[key].unitProjectTypeId != undefined &&
                                        $errors.projectTypes[key].unitProjectTypeId
                                          ? 'error'
                                          : ''}"
                                      >
                                        <div class="position-relative w-100">
                                          <Select
                                            isDisabled={true || disabledAllFields}
                                            containerStyles="min-width:200px;"
                                            class="form-control select-project-type"
                                            name={'projectTypes[' + key + ']'}
                                            bind:selectedValue={selectedProjectTypes[key].label}
                                            showChevron={true}
                                            isClearable={true}
                                            placeholder="Project"
                                            on:select={(ev) => {
                                              if (
                                                $form.projectTypes[key].unitProjectTypeId !=
                                                ev.detail.id
                                              ) {
                                                $form.projectTypes[key].unitProjectTypeId =
                                                  ev.detail.id;
                                                handleChange(
                                                  customInputEvent(
                                                    `projectTypes[${key}].unitProjectTypeId`,
                                                    ev.detail.id,
                                                  ),
                                                );
                                              }
                                            }}
                                            items={projectTypes}
                                            containerClasses="form-control"
                                            optionIdentifier="id"
                                            getSelectionLabel={(option) => {
                                              return option.name;
                                            }}
                                            getOptionLabel={(option) => {
                                              return option.name;
                                            }}
                                          />
                                          {#if $errors.projectTypes != undefined && $errors.projectTypes[key] != undefined && $errors.projectTypes[key].unitProjectTypeId != undefined}
                                            <label
                                              for=""
                                              class="formError"
                                              >{$errors.projectTypes[key].unitProjectTypeId}</label
                                            >
                                          {/if}
                                        </div>
                                        <!-- {#if key == 0}
														  <div class="add-more-btn  d-flex align-itms-center  justify-content-start">
															<button disabled={disabledAllFields} class="bg-transparent shadow-none border-0 color-blue" on:click={() => addProjectType()}>+ Add</button>
														  </div>
												   {:else} -->
                                        <div
                                          class="add-more-btn d-flex align-itms-center justify-content-start"
                                        >
                                          <button
                                            disabled={disabledAllFields}
                                            class="btn bg-transparent shadow-none btn-link px-0 mb-0 box-shadow-none border-0 font-size-12 color-red"
                                            on:click={() => {
                                              deleteProjectType(key);
                                            }}
                                          >
                                            <img
                                              alt=""
                                              class="icon-16 me-1"
                                              src="/images/trash.svg"
                                            />
                                            Remove
                                          </button>
                                        </div>
                                        <!-- {/if} -->
                                      </div>
                                    </div>
                                  </div>
                                {/each}
                              </div>
                            </div>
                          </div>
                        </div>
                      {/if}
                      {#if $form.taskType == taskTypeOptions.project}
                        <div class="row fade show">
                          <div class="col-md-12">
                            <div
                              class="form-group mb-3 select-block select-client-type d-flex flex-column position-relative {$errors.unitProjectId
                                ? 'error'
                                : ''}"
                            >
                              <label
                                for=""
                                class="form-label">Project:</label
                              >
                              <Select
                                isDisabled={disabledAllFields}
                                bind:selectedValue={selectedUnitProjectId}
                                showChevron={true}
                                isClearable={true}
                                name="unitProjectId"
                                placeholder="Select: Project One"
                                on:select={(ev) => {
                                  $form.unitProjectId = ev.detail.id;
                                  handleChange(customInputEvent('unitProjectId', ev.detail.id));
                                }}
                                on:clear={(ev) => {
                                  $form.unitProjectId = '';
                                }}
                                containerClasses="form-control"
                                items={internalProjects}
                                optionIdentifier="id"
                                getSelectionLabel={(option) => {
                                  return option.name;
                                }}
                                getOptionLabel={(option) => {
                                  return option.name;
                                }}
                              />
                              {#if $errors.unitProjectId != undefined}
                                <label
                                  for=""
                                  class="formError">{$errors.unitProjectId}</label
                                >
                              {/if}
                            </div>
                          </div>
                        </div>
                      {/if}
                    </div>
                  </div>
                </div>
                <!-- Tabs End -->
                <div class="pt-3 pb-3">
                  <div class="">
                    <div class="form-label mb-0">
                      <div class="checkbox c-checkbox">
                        <label class="text-nowrap">
                          <input
                            disabled={disabledAllFields}
                            type="checkbox"
                            name=""
                            checked={$form.recurring == 1}
                            on:change={(event) => {
                              $form.recurring = event.target.checked ? 1 : 0;
                              handleChange(
                                customInputEvent(`recurring`, event.target.checked ? 1 : 0),
                              );
                            }}
                            value="1"
                          />
                          <span class="check-img" />
                          Recurring
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {#if $form.recurring == 1}
                  <div class="row align-items-center mb-3 position-relative">
                    {#each recurringTypes as item}
                      <div class="col mb-3">
                        <div class="form-label mb-0">
                          <div class="radio c-radio">
                            <label>
                              <input
                                type="radio"
                                name="recurringType"
                                value={item.id}
                                disabled={disabledAllFields}
                                checked={$form.recurringType == item.id &&
                                  $form.recurringCustom == 0}
                                on:change={(event) => {
                                  $form.recurringType = item.id;
                                  $form.recurringCustom = 0;
                                  resetRecurringData();
                                  handleChange(
                                    customInputEvent('recurringType', $form.recurringType),
                                  );
                                }}
                              />
                              <span class="check-img-blue" />
                              {item.name}
                            </label>
                          </div>
                        </div>
                      </div>
                    {/each}
                    <!-- <div class="col mb-3">
					<div class="form-label mb-0">
					  <div class="radio c-radio">
						<label>
						  <input type="radio" name="recurringType" value="{recurringTypeOptions.daily}"
						  disabled={disabledAllFields}
							checked={$form.recurringType==recurringTypeOptions.daily && $form.recurringCustom==0}
							on:change={(event)=>{
								$form.recurringCustom=0;
								$form.recurringType=recurringTypeOptions.daily
								resetRecurringData();
								handleChange(customInputEvent(`recurringType`, event.target.checked?recurringTypeOptions.daily:""));
							  }}
						  />
							<span class="check-img" />
						  Daily
						</label>
					  </div>
					</div>
				  </div>
				  <div class="col mb-3">
					<div class="form-label mb-0">
					  <div class="radio c-radio">
						<label>
						  <input type="radio" name="recurringType" value="{recurringTypeOptions.weekly}"
						  disabled={disabledAllFields}
						  checked={$form.recurringType==recurringTypeOptions.weekly && $form.recurringCustom==0}
						  on:change={(event)=>{
							 $form.recurringCustom=0;
							 $form.recurringType=recurringTypeOptions.weekly;
							 resetRecurringData();
							 handleChange(customInputEvent(`recurringType`, event.target.checked?recurringTypeOptions.weekly:""));
						  }}
						  />
						   <span class="check-img" />
						  Weekly
						</label>
					  </div>
					</div>
				  </div>
				  <div class="col mb-3">
					<div class="form-label mb-0">
					  <div class="radio c-radio">
						<label>
						  <input type="radio" name="recurringType" value="{recurringTypeOptions.monthly}"
						  disabled={disabledAllFields}
							 checked={$form.recurringType==recurringTypeOptions.monthly && $form.recurringCustom==0}
							 on:change={(event)=>{
							   $form.recurringCustom=0;
							   $form.recurringType=recurringTypeOptions.monthly;
							   resetRecurringData();
							   handleChange(customInputEvent(`recurringType`, event.target.checked?recurringTypeOptions.monthly:""));
							 }}
						   />
						   <span class="check-img" />
						  Monthly
						</label>
					  </div>
					</div>
				  </div>
				  <div class="col mb-3">
					<div class="form-label mb-0">
					  <div class="radio c-radio">
						<label class="text-nowrap">
						  <input type="radio" name="recurringType" value="{recurringTypeOptions.quarterly}"
						  disabled={disabledAllFields}
							  checked={$form.recurringType==recurringTypeOptions.quarterly && $form.recurringCustom==0}
							  on:change={(event)=>{
								$form.recurringCustom=0;
								$form.recurringType=recurringTypeOptions.quarterly;
								resetRecurringData();
								handleChange(customInputEvent(`recurringType`, event.target.checked?recurringTypeOptions.quarterly:""));
							  }}
						  />
						   <span class="check-img" />
						  Quarterly
						</label>
					  </div>
					</div>
				  </div>
				  <div class="col mb-3">
					<div class="form-label mb-0">
					  <div class="radio c-radio">
						<label class="text-nowrap">
						  <input type="radio" name="recurringType" value="{recurringTypeOptions.annually}"
						  disabled={disabledAllFields}
							   checked={$form.recurringType==recurringTypeOptions.annually && $form.recurringCustom==0}
							   on:change={(event)=>{
								  $form.recurringCustom=0;
								  $form.recurringType=recurringTypeOptions.annually;
								  resetRecurringData();
								   handleChange(customInputEvent(`recurringType`, event.target.checked?recurringTypeOptions.annually:""));
								 }}
						  />
						   <span class="check-img" />
						  Annually
						</label>
					  </div>
					</div>
				  </div>
				   -->
                    <div class="col mb-3">
                      <div class="form-label mb-0">
                        <div class="radio c-radio">
                          <label class="text-nowrap">
                            <input
                              type="radio"
                              name="recurringCustom"
                              checked={$form.recurringCustom == 1}
                              disabled={disabledAllFields}
                              on:change={(event) => {
                                $form.recurringType = '';
                                $form.recurringCustom = 1;
                                handleChange(customInputEvent(`recurringType`, ''));
                                handleChange(
                                  customInputEvent(
                                    `recurringCustom`,
                                    event.target.checked ? 1 : '',
                                  ),
                                );
                                resetRecurringData();
                              }}
                              value={recurringTypeOptions.custom}
                            />
                            <span class="check-img" />
                            Custom
                          </label>
                        </div>
                      </div>
                    </div>

                    {#if $form.recurringCustom == 0 && $errors.recurringType != undefined}
                      <label
                        for=""
                        class="formError recuring-error">{$errors.recurringType}</label
                      >
                    {/if}

                    {#if $form.recurringCustom == 1}
                      <ReccuringCustom
                        disabledAllFields={disabledAllFields}
                        form={form}
                        errors={errors}
                        handleChange={handleChange}
                      />
                    {/if}

                    {#if $form.recurringCustom == 1 || $form.recurringType == recurringTypeOptions.monthly || $form.recurringType == recurringTypeOptions.quarterly || $form.recurringType == recurringTypeOptions.annually}
                      <TaskSchedule
                        bind:this={TaskScheduleOpenRef}
                        dateRecurringSubTypes={openDateRecurringSubType}
                        type={1}
                        disabledAllFields={disabledAllFields}
                        form={form}
                        errors={errors}
                        handleChange={handleChange}
                        recurringType={$form.recurringType}
                        recurringTypeOptions={recurringTypeOptions}
                      />
                      <TaskSchedule
                        bind:this={TaskScheduleDueRef}
                        dateRecurringSubTypes={dueDateRecurringSubType}
                        type={2}
                        disabledAllFields={disabledAllFields}
                        form={form}
                        errors={errors}
                        handleChange={handleChange}
                        recurringType={$form.recurringType}
                        recurringTypeOptions={recurringTypeOptions}
                      />
                    {/if}
                  </div>
                {/if}
                <div
                  class="add-sub-task tabs-block p-3"
                  id="sub_task_area_block"
                >
                  <div class="tabs-area bg-white">
                    <div class="bg-white tabs-content-area">
                      {#if disabledAllFields === false}
                        <button
                          disabled={disabledAllFields}
                          on:click={addSubTask}
                          class="d-flex flex-row bg-transparent border-0 rounded mb-0 cursor add-subtask"
                        >
                          <label
                            for=""
                            class="form-label mb-0 outline-none add-subtask-button curso"
                          >
                            + Add subtask
                          </label>
                        </button>
                      {/if}

                      {#each $form.subTaskTemplates as item, key (item)}
                        <div
                          class="mt-1 subtask-list-item"
                          animate:flip
                          draggable={false}
                          on:dragstart={(event) => dragstart(event, key)}
                          on:drop|preventDefault={(event) => drop(event, key)}
                          ondragover="return false"
                          on:dragenter={() => (hovering = key)}
                          class:is-active={hovering === key}
                        >
                          <div class="d-flex flex-row align-items-center add-task-input">
                            <div
                              class="w-100 position-relative input-subtask flex-row d-flex align-items-center"
                            >
                              {#if disabledAllFields === false}
                                <img
                                  draggable={true}
                                  class="btn-drag"
                                  alt=""
                                  src="/images/drag-icon.svg"
                                />
                              {/if}
                              <textarea
                                disabled={disabledAllFields}
                                bind:value={$form.subTaskTemplates[key].name}
                                on:keyup={(event) => {
                                  if (event.key == 'Enter' && event.target.value.trim() != '') {
                                    addSubTask();
                                  }
                                }}
                                class="mb-0 w-100 h-100 border-top-0 border-end-0 border-start-0 sub-task-input ms-2 {disabledAllFields &&
                                item.isNa != undefined &&
                                item.isNa != 0
                                  ? 'text-decoration-line-through'
                                  : ''}"
                                placeholder="Subtask Name"
                                maxLength={configItem.maxLength.input}
                                type="text"
                              />
                              {#if $form.subTaskTemplates[key].name.length > 0}
                                <span
                                  class="position-absolute"
                                  style="font-size: 10px;right: 15px;"
                                  >{$form.subTaskTemplates[key].name.length}/{configItem.maxLength
                                    .input}</span
                                >
                              {/if}
                              <div class="hover-btn d-none position-absolute">
                                {#if disabledAllFields === false}
                                  <button
                                    disabled={disabledAllFields}
                                    class="btn btn-link mr-0 p-0 shadow-none border-0 bg-transparent"
                                    on:click={() => {
                                      let oldSubTasks = $form.subTaskTemplates;
                                      oldSubTasks.splice(key, 1);
                                      $form.subTaskTemplates = oldSubTasks;
                                    }}
                                  >
                                    <img
                                      class="btn-cancel"
                                      alt=""
                                      src="/images/cancel.svg"
                                    />
                                  </button>
                                {/if}
                              </div>
                            </div>

                            {#if disabledAllFields}
                              <button
                                data-bs-placement="top"
                                data-bs-toggle="popover"
                                data-bs-trigger="hover"
                                data-bs-content={item.isNa == undefined || item.isNa == 0
                                  ? 'Click here to mark the sub task as not applicable.'
                                  : 'Click here to mark the sub task as applicable'}
                                class="btn btn-link mr-0 p-0 shadow-none border-0 shadow-none bg-transparent task-button-applicable subtask_popover"
                                on:click={() => (item.isNa = item.isNa == 1 ? 0 : 1)}
                              >
                                {#if item.isNa == undefined || item.isNa == 0}
                                  <img
                                    class="btn-applicable"
                                    alt=""
                                    src="/images/task-not-applicable.svg"
                                  />
                                {:else}
                                  <img
                                    class="btn-applicable"
                                    alt=""
                                    src="/images/task-applicable.svg"
                                  />
                                {/if}
                              </button>
                            {/if}
                          </div>
                        </div>
                      {/each}
                    </div>
                  </div>
                </div>
                <hr class="hrline" />
                <!-- Sub Task Block -->
                <div class="row">
                  <div class="col-md-12 add-task-file-upload">
                    <!-- <UploadFiles/> -->
                    <SimpleFileUploader
                      isDisabled={disabledAllFields}
                      on:fileChanged={(event) => {
                        if (event.detail.type == 'add') {
                          $form.attachments.push(event.detail);
                        } else if (event.detail.type == 'delete') {
                          let index = searchKeyByValue(
                            $form.attachments,
                            'fileName',
                            event.detail.fileName,
                          );
                          if (index !== -1) {
                            $form.attachments.splice(index, 1);
                          }
                        } else if (event.detail.type == 'uploading') {
                          isFormPending = true;
                        } else if (event.detail.type == 'uploaded') {
                          isFormPending = false;
                        }
                      }}
                      photoUrl={displayfiles}
                      allFileType={true}
                      allowMultiple={true}
                      requestFrom="task_template"
                      entityId={$form.id}
                    />
                    <div class="form-group mb-3">
                      <label
                        for=""
                        class="form-label">Links</label
                      >
                      <div class="d-flex flex-row">
                        <div class="position-relative w-100 d-flex">
                          <div class="{urlInvalid != '' ? 'error' : ''} w-100 position-relative">
                            {#if urlInvalid != ''}
                              <label
                                class="formError"
                                for="example-text-input">{urlInvalid}</label
                              >
                            {/if}
                            <input
                              disabled={disabledAllFields}
                              type="text"
                              class="form-control"
                              name="example-text-input"
                              on:keyup={(event) => {
                                if (event.key == 'Enter') {
                                  addUrl();
                                }
                              }}
                              placeholder="Enter URL"
                              on:change={() => (urlInvalid = '')}
                              bind:value={newUrl}
                            />
                          </div>
                          <input
                            type="text"
                            class="form-control"
                            name="example-text-input"
                            placeholder="Enter URL Title"
                            bind:value={newTitle}
                            on:keyup={(event) => {
                              if (event.key == 'Enter') {
                                addUrl();
                              }
                            }}
                            style="margin-left:5px"
                          />
                        </div>
                        <button
                          disabled={disabledAllFields}
                          class="btn background-blue mb-0 text-white px-4 add-task font-size-12 btn-primary ms-2"
                          on:click={addUrl}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                    <ul class="filte-upload font-size-13 mb-3">
                      {#each $form.urls as item, key}
                        <li class="d-flex flex-row align-items-center mb-1">
                          <img
                            class="icon-16 me-1"
                            alt=""
                            src="/images/globe.svg"
                          />
                          <span class="text-break"
                            ><a
                              href={item.url}
                              target="_blank">{item.title.trim() != '' ? item.title : item.url}</a
                            ></span
                          >
                          <button
                            disabled={disabledAllFields}
                            class="close bg-transparent border-0 p-0 ms-2 mb-0"
                            on:click={() => {
                              let oldUrls = $form.urls;
                              oldUrls.splice(key, 1);
                              $form.urls = oldUrls;
                            }}
                            ><img
                              alt=""
                              src="/images/cancel.svg"
                            /></button
                          >
                        </li>
                      {/each}
                    </ul>

                    {#if $form.taskType == 1}
                      <div class="row align-items-center">
                        <div class="col-md-3 mb-3">
                          <label
                            for=""
                            class="text-nowrap form-label mb-0 svelte-u8qf5n"
                          >
                            Responsible Party:
                          </label>
                        </div>
                        <div class="col-md-3">
                          <div class="col-md-3 mb-3">
                            <div class="form-label mb-0">
                              <div class="radio c-radio">
                                <label class="text-nowrap">
                                  <input
                                    disabled={disabledAllFields}
                                    type="radio"
                                    name="responsibleParty"
                                    checked={$form.responsibleParty == 1}
                                    on:change={(event) => ($form.responsibleParty = 1)}
                                  />
                                  <span class="check-img" />
                                  {getResposiblePartyLabel($form)}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="col-md-3 mb-3">
                            <div class="form-label mb-0">
                              <div class="radio c-radio">
                                <label class="text-nowrap">
                                  <input
                                    disabled={disabledAllFields}
                                    type="radio"
                                    name="responsibleParty"
                                    checked={$form.responsibleParty == 2}
                                    on:change={(event) => ($form.responsibleParty = 2)}
                                  />
                                  <span class="check-img" />
                                  Client
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    {/if}
                  </div>
                </div>
                <!-- Sub Task Block -->
              {/if}
              <!-- unit if condition -->
            </div>
          </div>

          {#if $form.unitId > 0}
            <div class="modal-footer rounded-0">
              <div
                class="d-flex flex-row justify-content-end w-100
					align-items-center"
              >
                <div>
                  <button
                    on:click={handleSubmit}
                    class="btn shadow-none background-blue mb-0 font-size-12 text-white
						add-task px-4 add-task-btn"
                    disabled={isFormPending}
                  >
                    {#if isFormPending}
                      <Loader />
                    {:else}Save{/if}
                  </button>
                </div>
              </div>
            </div>
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>

<CreateMailTemplate
  bind:this={taskMailModal}
  entityId={$form.id}
  handleDelete={(params) => {
    setTimeout(() => {
      deleteEmailTemplate();
    }, 250);
  }}
  handleClick={(params) => {
    $form.emailTemplate = 1;
    $form.emailTemplateSubject = params.emailSubject;
    $form.emailTemplateBody = params.emailBody;
    $form.emailTemplateAttachments = params.attachments;
  }}
/>

<style lang="scss">
  .subtask-list-item.is-active {
    background-color: #3273dc;
    color: #fff;
  }
  .btn-applicable {
    width: 20px !important;

    height: auto !important;
    margin-top: 2px;
  }
  .add-more-btn {
    width: 90px;
    flex: 0 0 90px;
    padding-left: 10px;
  }
  .filte-upload {
    list-style: none;
    padding: 0px;
    margin: 0px;

    .close {
      img {
        width: 12px;
        height: 12px;
      }
    }
  }
  .tabs-content-area {
    svg {
      fill: #000;
    }
  }
  .hrline {
    margin-left: -15px;
    /* margin-right: -15px; */
    background: var(--border-color);
  }
  .client-tabs-block {
    border: 1px solid $input-border-color;
    padding: 10px 20px;
  }

  .add-client-title {
    .hrline {
      background: $input-border-color;
      height: 1px;
    }
  }

  .input-subtask {
    textarea {
      padding-right: 125px;
      height: 30px;
      line-height: 29px;
      overflow: hidden;
      padding-top: 0;
      padding-bottom: 0;
    }
    input {
      padding-right: 25px;
    }
    img {
      width: 12px;
      height: 12px;
    }
    &:hover {
      .hover-btn {
        display: block !important;
      }
    }
    .hover-btn {
      right: 0px;
      top: 0px;
    }
  }
  .recuring-error {
    right: auto;
    left: 13px;
    display: inline-block;
    width: 167px;
  }
</style>
